import api from "../lib/api";

export type NotificationItem = {
  id: string | number;
  title: string;
  message: string;
  created_at: string;
  is_read: boolean;
  link?: string | null;
};

const toItem = (r: any): NotificationItem => ({
  id: r?.id ?? r?.pk ?? r?.uuid ?? String(Math.random()),
  title: String(r?.title ?? r?.subject ?? "Notification"),
  message: String(r?.message ?? r?.body ?? r?.content ?? ""),
  created_at: String(r?.created_at ?? r?.created ?? r?.timestamp ?? ""),
  is_read: Boolean(r?.is_read ?? r?.read ?? false),
  link: r?.link ?? r?.url ?? null,
});

export async function listNotifications(params: { page?: number; page_size?: number } = {}) {
  const { data } = await api.get("/notifications/", { params });
  const results = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];
  return {
    results: results.map(toItem) as NotificationItem[],
    count: Number(data?.count ?? results.length) || 0,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
  };
}

export async function unreadCount(): Promise<number> {
  const { data } = await api.get("/notifications/unread_count/");
  return Number(data?.unread ?? data?.count ?? data ?? 0) || 0;
}

export async function markAllRead(): Promise<void> {
  await api.post("/notifications/mark-all-read/");
}

export async function markRead(id: string | number, data: any): Promise<void> {
  await api.post(`/notifications/${id}/read/`, data );
}
